import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginPage.vue'
import HomePage from '../views/HomePage.vue'
import ApiDocLayout from '../views/ApiDocLayout.vue'
import ApiDocView from '@/views/ApiDoc.vue'
import DataDisplayView from '@/components/DataDisplay.vue';
import TestSnView from '@/components/TestSn.vue';
import BlackSnView from '@/components/BlackSn.vue';
import OutCodeView from '@/components/OutCode.vue';
import SnMycarInfoView from '@/components/SnMycarInfo.vue';
import VinListView from '@/components/VinList.vue';
import DataSwitchView from '@/components/DataSwitch.vue';
import VinIMMOView from '@/components/VinIMMO.vue';
import FileDownloadView from '@/components/FileDownload.vue';
import DeliverFunctionView from '@/components/DeliverFunction.vue';
import ProductGuideView from '@/components/ProductGuide.vue';
import MazdaAllView from "@/components/MazdaAll.vue";
import FordConfigWorkspaceView from '@/components/ford/FordConfigWorkspace.vue';
import SgmMenuView from '@/components/SgmMenu.vue';
import { isAuthenticated } from '../api/users'
import store from '../store'
import { canAccessRoute } from '../utils/adminAccess.mjs'
const routes = [
  { path: '/login', name: 'LoginView', component: LoginView, },
  {
    path: '/', name: 'HomePage', component: HomePage, meta: { requiresAuth: true },
    children: [
      { path: '', name: 'DataDisplay', component: DataDisplayView },
      { path: 'fordconfig', name: 'FordConfig', component: FordConfigWorkspaceView, meta: { requiresSsvip: true } },
      { path: 'testsn', name: 'TestSn', component: TestSnView },
      { path: 'blacksn', name: 'BlackSn', component: BlackSnView },
      { path: 'outcode', name: 'OutCode', component: OutCodeView },
      { path: 'snmycarinfo', name: 'SnMycarInfo', component: SnMycarInfoView },
      { path: 'vinlist', name: 'VinList', component: VinListView },
      { path: 'dataswitch', name: 'DataSwitch', component: DataSwitchView },
      { path: 'vinimmo', name: 'VinIMMO', component: VinIMMOView },
      { path: 'filedownload', name: 'FileDownload', component: FileDownloadView },
      { path: 'deliverfunction', name: 'DeliverFunction', component: DeliverFunctionView },
      { path: 'productguide', name: 'ProductGuide', component: ProductGuideView },
      { path: "mazda-all", name: 'Mazda', component: MazdaAllView },
      { path: "sgm", name: 'SgmMenu', component: SgmMenuView, meta: { requiresSgm: true } },
      //{ path: "apidoc", name: 'ApiDoc', component: ApiDocView, meta: { aside: 'apidoc' } }
      // å¶ä»å­è·¯ç±...  
    ]
  },
  {
    path: '/apidoc',
    component: ApiDocLayout,
    children: [
      {
        path: '',
        name: 'ApiDoc',
        component: ApiDocView
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// å¨å±åç½®å®å«  
// è®¤è¯ç¼å­éç½®
let authCache = {
  value: null,
  time: 0,
  duration: 10 * 60 * 1000  // 10åé
};

// å¸¦ç¼å­çè®¤è¯æ£æ¥
async function getCachedAuth() {
  const now = Date.now();

  if (authCache.value === true &&
      (now - authCache.time) < authCache.duration) {
    return true;
  }

  const result = await isAuthenticated();

  // åªç¼å­ true
  if (result === true) {
    authCache.value = true;
    authCache.time = now;
  }

  return result;
}

// å¯¼åºæ¸é¤ç¼å­çå½æ°
export function clearAuthCache() {
  authCache.value = null;
  authCache.time = 0;
}

// è·¯ç±å®å«ï¼ä½¿ç¨å¸¦ç¼å­çå½æ°ï¼
router.beforeEach(async (to, from, next) => {
  const isAuth = await getCachedAuth();

  if (to.name === 'LoginView' && isAuth) {
    next({ name: 'HomePage', replace: true });
    return;
  }

  if (!isAuth && to.name !== 'LoginView') {
    next({ name: 'LoginView', replace: true });
    return;
  }

  if (isAuth && !canAccessRoute(store.state.userData, to)) {
    next({ name: 'DataDisplay', replace: true });
    return;
  }

  next();
});



export default router
